export enum Queues {
    tracing = 'tracing',
    report = 'report',
    resolution = 'entity_resolution'
}

export enum ResolutionQueueJobs {
    full = 'full',
}

export enum ReportQueueJobs {
    create = 'create'
}

export enum TracingQueueJobs {
    trace = 'trace',
   // autoTracing = 'auto_tracing',
    cancelTracing = 'cancel_auto_tracing'
}

export enum ContentType {
    MoneyFlow = 'MoneyFlow',
    Report = 'Report'
}

export enum BlockchainNetwork {
    algorand = 'algorand',
    bitcoin = 'btc',
    cardano = 'cardano',
    ethereum = 'eth',
    filecoin = 'filecoin',
    hedera = 'hedera',
    ripple = 'ripple',
    solana = 'solana',
    stellar = 'stellar',
    tezos = 'tezos',
    tron = 'tron',
    // EVM chains on GraphQL v2 (blockchains/evmV2Networks.ts). Codes are
    // stored in varchar(5) columns, hence the short forms.
    bsc = 'bsc',
    matic = 'matic',
    arbitrum = 'arb',
    optimism = 'op',
    base = 'base',
    robinhood = 'rhood',
    arc = 'arc'
}

export const USER_TAG_LIMIT = 3

export enum SelectionModes {
    include = 'include',
    exclude = 'exclude'
}

export const ONE_CURRENCY_BLOCKCHAIN_LIST = [
    BlockchainNetwork.algorand,
    BlockchainNetwork.bitcoin,
    BlockchainNetwork.hedera
]

export const filterKeys = [
    'transfer_sender_address', 'transfer_receiver_address', 'amount_usd', 'currency_smart_contract_address',
    'id', 'tx_timestamp', 'tracing_excluded'
] as const

export const FEATURES = {
    bitcoin: 'btc_chain',
    forceEntityResolution: 'force_entity_resolution',
    coinpathAPI: 'coinpath_api',
} as const


export const BitcoinNetworkNames = {
    bitcoin: 'Bitcoin',
    dash: 'Dash',
    dogecoin: 'Dogecoin',
    litecoin: 'Litecoin',
}

